import { property } from '../config/property';

function getVideoSource(url) {
  if (url.endsWith('.mp4')) return { type: 'video', src: url };
  const youtube = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
  if (youtube) return { type: 'embed', src: `https://www.youtube-nocookie.com/embed/${youtube[1]}` };
  const vimeo = url.match(/vimeo\.com\/(\d+)/);
  if (vimeo) return { type: 'embed', src: `https://player.vimeo.com/video/${vimeo[1]}` };
  return null;
}

export default function VideoTour() {
  const video = property.videoUrl ? getVideoSource(property.videoUrl) : null;
  if (!video) return null;

  return (
    <section className="section video-section">
      <div className="section-heading">
        <p className="eyebrow">The video tour</p>
        <h2>Take a Look Inside</h2>
        <p>Explore the home before scheduling your private tour.</p>
      </div>
      <div className="video-frame">
        {video.type === 'video'
          ? <video src={video.src} controls playsInline preload="metadata" aria-label="Property video tour" />
          : <iframe src={video.src} title="Property video tour" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen />}
      </div>
    </section>
  );
}